import { Page } from "@/models/page-models/Page";

export const ProductionReportProductionReportId: Page = {
  "path": "production-report/:productionReportId",
  "name": "Edit Production Report",
  "props": {
    "data": {
      "title": "Edit Production Report",
      "printable": "FALSE",
      "url": "production-report/:productionReportId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.factoryTicket._id",
                  "label": "Select Factory Ticket",
                  "disabled": "TRUE",
                  "items": "fetchedData.factoryTickets.data",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,factoryTicketDescription,{{__item}})",
                  "validationKey": "order"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.machine",
                  "label": "Select Process",
                  "disabled": "TRUE",
                  "showIf": "{{formData.factoryTicket._id}}",
                  "items": "fetchedData.processes",
                  "itemText": "machine",
                  "itemValue": "_key",
                  "formula": "fn(HELPER,productionProcess,{{__item}})",
                  "validationKey": "process"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "formData.factoryTicket.order",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket.order}}"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Production Entry Details",
                  "showIf": "{{formData.factoryTicket}}"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.machine",
                  "label": "Search Machine",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "items": "fetchedData.machines.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "validationKey": "machine"
                },
                {
                  "type": "input",
                  "variable": "formData.numberOfMen",
                  "label": "Number of Men",
                  "unit": "men",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "numberOfMen"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.standardSpeed",
                  "label": "Standard Speed",
                  "unit": "m/min",
                  "disabled": "TRUE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "standardSpeed"
                },
                {
                  "type": "input",
                  "variable": "formData.activeSpeed",
                  "label": "Active Speed",
                  "unit": "m/min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "activeSpeed"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.setupDT",
                  "label": "Setup DT",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "setupDT"
                },
                {
                  "type": "input",
                  "variable": "formData.maintenanceDT",
                  "label": "Maintenance DT",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "maintenanceDT"
                },
                {
                  "type": "input",
                  "variable": "formData.productionDT",
                  "label": "Production DT",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "productionDT"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.hourMeterStart",
                  "label": "Hour Meter Start",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "hourMeterStart"
                },
                {
                  "type": "input",
                  "variable": "formData.hourMeterEnd",
                  "label": "Hour Meter End",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "hourMeterEnd"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.setupWaste",
                  "label": "Setup Waste",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "setupWaste"
                },
                {
                  "type": "input",
                  "variable": "formData.maintenanceWaste",
                  "label": "Maintenance Waste",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "maintenanceWaste"
                }
              ]
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.trimWaste",
                  "label": "Trim Waste",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "trimWaste"
                },
                {
                  "type": "input",
                  "variable": "formData.productionWaste",
                  "label": "Production Waste",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "productionWaste"
                }
              ]
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.productionDate",
                  "label": "Production Date",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}",
                  "validationKey": "productionDate"
                },
                {
                  "type": "timePicker",
                  "variable": "formData.timeFrom",
                  "label": "{{translated('time_from')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}"
                },
                {
                  "type": "timePicker",
                  "variable": "formData.timeTo",
                  "label": "{{translated('time_to')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.factoryTicket}}"
                },
                {
                  "type": "label",
                  "variable": "formData.timeSpent",
                  "label": "Total Hours",
                  "showIf": "{{formData.factoryTicket}}",
                  "labelType": "formula",
                  "formula": "fn(TIME_DIFF,{{formData.timeFrom}},{{formData.timeTo}})",
                  "storeFormulaValue": true
                }
              ]
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "custom_ProductionReport",
                  "variable": "formData.process",
                  "label": "Production Report",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.processes}}",
                  "config": {
                    "goodsVariable": "fetchedData.orderProcesses.data.goods",
                    "processesVariable": "fetchedData.orderProcesses.data.processes",
                    "resetData": false,
                    "wipVariable": "fetchedData.factoryWip.data",
                    "orderVariable": "formData.factoryTicket.order"
                  }
                }
              ]
            },
            {
              "name": "13",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "saveProductionReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "('{{formData.approval}}'=='pending')",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductionReport",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/productionreport/{{__params.productionReportId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productionReport",
          "arg3Key": "fnsAfterSubmit",
          "arg3Value": "[{\"name\":\"copyProductionReport\",\"executionOrder\":1},{\"name\":\"getOrderProcesses\",\"executionOrder\":2},{\"name\":\"copyMachineId\",\"executionOrder\":3}]",
          "arg4Key": "serviceConfig",
          "arg4Value": "{\"service\":\"GET_WIP\",\"args\":[\"fetchedData.productionReport.data.0\"]}"
        },
        "name": "getProductionReport"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getFactoryTickets",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/factory-ticket/to-produce",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.factoryTickets"
        },
        "name": "getFactoryTickets"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMachines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/machines/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.machines"
        },
        "name": "getMachines"
      }
    ],
    "functions": [
      {
        "name": "copyProductionReport",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.productionReport.data.0",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "copyMachineId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.process._key",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.machine"
      },
      {
        "name": "getOrderProcesses",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/factoryticket/orderprocess?id={{formData.factoryTicket.order._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.orderProcesses",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "convertProcesses",
        "arg4Key": "addToState",
        "arg4Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.orderProcesses.data.goods\"}"
      },
      {
        "name": "convertProcesses",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.orderProcesses.data",
        "arg2Key": "sourceFn",
        "arg2Value": "getConvertedProcesses",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object",
        "arg5Key": "append",
        "arg5Value": "TRUE"
      },
      {
        "name": "getConvertedProcesses",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "processes": "fn(TO_ARRAY,{{__selectedObject.processes}})"
        },
        "useFormula": true
      },
      {
        "name": "saveProductionReport",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/productionreport",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "redirectToMyProductionReports"
      },
      {
        "name": "redirectToMyProductionReports",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/my-production-reports"
      }
    ]
  },
  "forRole": "PRODUCTION_OPERATOR",
  "visible": false
}